import { API } from "@/lib/api";

async function call(path, { method = "GET", body } = {}) {
  const res = await fetch(`${API}${path}`, {
    method,
    credentials: "include",
    headers: body ? { "Content-Type": "application/json" } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  let payload = null;
  try {
    payload = await res.json();
  } catch {
    /* no body */
  }
  if (!res.ok) {
    const err = new Error(payload?.detail || `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return payload;
}

export const historyApi = {
  list: () => call("/history"),
  upsert: (conv) =>
    call(`/history/${encodeURIComponent(conv.id)}`, {
      method: "PUT",
      body: {
        id: conv.id,
        title: conv.title || "",
        messages: conv.messages || [],
        created_at: conv.createdAt,
        updated_at: conv.updatedAt,
        project_id: conv.projectId || null,
        kind: conv.kind || "chat",
      },
    }),
  remove: (id) => call(`/history/${encodeURIComponent(id)}`, { method: "DELETE" }),
  clear: () => call("/history", { method: "DELETE" }),
  importBulk: (conversations) =>
    call("/history/import", {
      method: "POST",
      body: {
        conversations: conversations.map((c) => ({
          id: c.id,
          title: c.title || "Untitled",
          messages: c.messages || [],
          created_at: c.createdAt,
          updated_at: c.updatedAt,
        })),
      },
    }),
};
